var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.ready
    ? _c("div", {}, [
        _vm.loading
          ? _c(
              "span",
              { staticClass: "loading" },
              [
                _c("ClipLoader", {
                  attrs: { color: "#2e3f50", loading: _vm.loading, size: 20 },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.lecturesStudentModel && _vm.lecturesStudentModel.length
          ? _c(
              "div",
              { staticClass: "StudentGroups__Container" },
              _vm._l(_vm.lecturesStudentModel, function (lecture) {
                return _c(
                  "div",
                  {
                    key: lecture.id,
                    staticClass: "StudentGroupsWidget__Component",
                  },
                  [_c("p", [_vm._v(_vm._s(_vm.lectureItem(lecture)))])]
                )
              }),
              0
            )
          : _vm._e(),
        !_vm.loading && !_vm.lecturesStudentModel.length
          ? _c("div", [_vm._v("אין הרצאות משויכות למשתמש")])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }